'use strict';

require('../../modals/message-popup/message-popup');

angular.module('far.helpers.showModalMessage', [
	'ui.bootstrap',
	'far.modals.message-popup',
	'templates'
])
.service('showModalMessage', function($uibModal) {
	function showModalMessage(messages, title) {
		var data = {
			title: function() {
				return title;
			},
			messages: function() {
				if (angular.isArray(messages)) {
					return messages;
				}

				return [messages];
			}
		};

		var modalInstance = $uibModal.open({
			templateUrl: '/modals/message-popup/message-popup.html',
			windowClass: 'modal-notice',
			controller: 'MessagePopupController as messagePopup',
			resolve: data
		});

		return modalInstance;
	}

	return showModalMessage;
});